import { Slugs } from 'common/urls/Slugs';
import { useMemo } from 'react';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { Routes } from '../Routes';
import { getSluggedPath } from '../utils/RouteUtilities';

/**
 * Hook for returning the home path.
 *
 * If a user has a cached zip code, then the home path is the explore page.
 * Otherwise it's the landing page.
 */
export const useHomePath = () => {
  const [zipCode] = useCachedZipCode();

  return useMemo(() => {
    if (zipCode) {
      return getSluggedPath(Routes.CONSUMER_EXPLORE, [{ slug: Slugs.ZIP_CODE, value: zipCode }]);
    }

    return Routes.CONSUMER_LANDING;
  }, [zipCode]);
};
